import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface DocumentLoaderOptions extends AjaxLoaderOptions {

}

export class DocumentLoader extends AbstractAjaxLoader<Document, DocumentLoaderOptions>{
    protected defaultOptions(): DocumentLoaderOptions {
        return {
            decoder: "document"
        }
    }
}

registerLoader("document", DocumentLoader);